<template>
  <div id="lista-especialidades">
    <div v-if="lista" :style="'padding: 20px; --cor-primaria:' + corPrimaria + '0A'">
      <span class="title">Especialidade: {{especialidade}}</span>
      <div class="pesquisa" v-if="exibeCampoBusca">
        <el-input
          class="search-input xs"
          placeholder="Pesquisar"
          v-model="searchText"
          suffix-icon="el-icon-search"
          clearable
          size="mini"
          @input="search()"
        >
        </el-input>
      </div>
      <span class="title">{{texto}}</span>
      <listagem :click-row="selectEspecialidade" :listagem-data="lista" :columns="columns" :icone="'Arrow_chevron'"></listagem>
      <dialog-default
        v-if="alerta"
        :show-close="false"
        custom-class="dialog-especialidades"
        :title="alerta.descricao"
        :open.sync="dialogVisible"
        width="47%"
      >
        <span>{{alerta.alerta}}</span>
        <span slot="footer" class="dialog-footer">
        <el-button class="btn-dialog" :style="`background-color: ${corBotaoSecundario}`" @click="nextStep">
          <span :style="`color: ${corTextoBotaoSecundario}`">Entendi</span>
        </el-button>
        </span>
      </dialog-default>
    </div>
  </div>
</template>
<script>
import Listagem from '@/components/Listagem/Listagem'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import ArrowButton from '@/components/listagemColumn/ArrowButton'
import DialogDefault from '@/components/DialogDefault/DialogDefault.vue'
export default {
  data () {
    return {
      lista: null,
      columns: [{ field: 'descricao', width: '490px' }, { field: '', component: ArrowButton }],
      alerta: null,
      dialogVisible: false,
      nome: '',
      searchText: ''
    }
  },
  components: { DialogDefault, Listagem },
  computed: {
    ...mapState('SetupApp', ['apiFuncionalidade', 'funcionalidade']),
    ...mapState('Func53', ['paciente', 'idAgenda']),
    ...mapGetters('SetupApp', ['estilo']),
    ...mapGetters('Func53', ['tipoServico', 'especialidadeDescricao']),
    texto () {
      return this.funcionalidade.parametros.textos.textoTelaTipoServico
    },
    corPrimaria () {
      return this.estilo.aplicacao.corPrimariaAplicacao
    },
    corBotaoSecundario () {
      return this.estilo.botaoSecundario.corBotaoSecundario
    },
    corTextoBotaoSecundario () {
      return this.estilo.botaoSecundario.corTextoBotaoSecundario
    },
    especialidade () {
      return this.especialidadeDescricao
    },
    exibeCampoBusca () {
      return true
    }
  },
  methods: {
    ...mapActions('Func53', ['setIdServico']),
    ...mapActions('BreadCrumbsStore', ['updateIten']),
    ...mapMutations('BreadCrumbsStore', ['SET_CURRENT_STEP']),
    selectEspecialidade (row) {
      this.nome = row.nome
      if (row.alerta) {
        this.alerta = row
      }

      let value
      this.ordem === 2 ? value = 3 : value = 2

      let step
      this.idAgenda === '2' ? step = 3 : step = value
      const data = { step: step, value: row.descricao }
      this.updateIten(data)
      this.setIdServico(row.idServico)
      if (this.alerta) {
        this.dialogVisible = true
      } else {
        this.nextStep()
      }
    },
    nextStep () {
      if (this.dialogVisible) {
        this.dialogVisible = false
      }
      if (this.$route.query.step === '4.1') {
        return this.$router.replace({ query: { step: 5 } })
      }
      return this.$router.replace({ query: { step: 4 } })
    },
    search () {
      let tipoServico = this.tipoServico
      if (this.searchText) {
        tipoServico = tipoServico.filter(item => item.descricao.toLowerCase().includes(this.searchText.toLowerCase()))
      }
      this.refreshServicos(tipoServico)
    },
    refreshServicos (novaLista) {
      this.lista = novaLista
    }
  },
  async created () {
    this.SET_CURRENT_STEP('3.1')
    this.lista = this.tipoServico
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@200&family=Open+Sans:wght@300&display=swap');
.title {
  font-family: 'Open Sans', sans-serif;
}
.pesquisa {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}
</style>
